import React from 'react';
import Logo from './Logo';
import {NavigationContext} from './Contexts/NavigationContext';
import {NavigationLink} from './Navigation';
import ContactForm7 from './Footer/ContactForm';
import MailchimpForm from './Footer/MailchimpForm';

const NewsletterSignup = () => {
	return (
		<section id="subscribe" className="widget widget_mailchimpsf_widget">
			<h3 className="widget-title">Sign up for our newsletter</h3>
			<MailchimpForm />
		</section>
	)
}
const ContactForm = () => {
	return (
		<section id="contact" className="widget widget_text">
			<h3 className="widget-title">Contact Us</h3>
			<ContactForm7 />
		</section>
	)
}
class Footer extends React.Component {
	render() {
		const nav = this.context;
		const items = nav['menu-2'].menu.items;
		return (
			<footer id="colophon" className="site-footer">
				<div id="footer-widgets" className="footer-widget-wrapper">
					<div className="footer-widget-wrapper-inner">
						<aside id="left-footer-widget" className="widget-area">
							<div className="footer-logo-social-media-links">
								<a href={global.config.baseURL} rel="home"><Logo/></a>
								<a aria-label="facebook" target="_blank" rel="noreferrer" href="https://www.facebook.com/blackoctopussound"><i className="fa fa-facebook" aria-hidden="true"></i> </a>
								<a aria-label="twitter" target="_blank" rel="noreferrer" href="https://twitter.com/_blackoctopus_"><i className="fa fa-twitter" aria-hidden="true"></i> </a>
								<a aria-label="youtube" target="_blank" rel="noreferrer" href="https://www.youtube.com/user/blackoctopussound"><i className="fa fa-youtube" aria-hidden="true"></i> </a>
							</div>
							<NewsletterSignup/>
						</aside>
						<aside id="center-footer-widget" className="widget-area">
							<h3 className="widget-title">Site Map</h3>
								<div className="menu-site-map-container">
									<ul id="footer-sitemap-menu" className="menu">
										{items.map((item,inx) => { 
											return <li key={inx} className={item.classes+" menu-item"}><NavigationLink url={item.url} title={item.title} icon={null} toggle={null} /></li>
										})}
									</ul>
								</div>				
						</aside>
						<aside id="right-footer-widget" className="widget-area">
							<ContactForm/>
						</aside>
					</div>
					<p className="recaptcha-text">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of Service</a> apply.</p>
				</div>
				<div className="site-info">
					<div className="alignleft">© {(new Date().getFullYear())} Black Octopus Sound <span className="sep"> | </span> All Rights Reserved</div>
					<div className="alignright">
						<a title="Privacy Policy" href="https://blackoctopus-sound.com/privacy-policy/">Privacy Policy</a> <span className="sep"> | </span> <a href="https://blackoctopus-sound.com/terms-of-service/">Terms of Service</a>
					</div>
				</div>
			</footer>
		)
	}
}
Footer.contextType = NavigationContext;
export default Footer